/**
 * Helper function to build `shouldForwardProp` object fro Mui's styled() to resolve the warning
 * `React does not recognize the `xxx` prop on a DOM element.  * If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase ... (omitted)`
 */
export const excludedFromForwardProps = (...props: string[]) => {
    return {
        shouldForwardProp: (prop: string) => !props.includes(prop),
    }
}
